﻿declare const window: Window & { dataLayer: Record<string, unknown>[] };

export const publishEvent = (eventName: string, eventValue?: unknown) =>
  publish({event: eventName, eventValue: eventValue});

export const publishSessionStorage = (value: Record<string, unknown>) => publish({event: "session-storage", ...value});

const publish = (value: Record<string, unknown>) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(value);
  } catch (error) {
    console.error(error);
  }
};
